import paper from "paper";

import { loadImage, makePaperProject } from "./utils.js";

const makeCanvas = (image) => {
  const canvas = document.createElement("canvas");
  canvas.width = image.width;
  canvas.height = image.height;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(image, 0, 0);
  return { canvas, ctx };
};

export const getPngOpacityRatioOverLimit = async (
  src,
  opacity_limit_percent
) => {
  const { canvas, ctx } = makeCanvas(await loadImage(src));
  const image_data = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const pixel_arr = image_data.data;
  let count_over_opacity_limit = 0;
  for (let i = 3; i < pixel_arr.length; i += 4) {
    if (pixel_arr[i] > (opacity_limit_percent / 100) * 255) {
      count_over_opacity_limit++;
    }
  }
  return (count_over_opacity_limit / pixel_arr.length) * 4 * 100;
};

const isDomElement = (o) => {
  return typeof HTMLElement === "object"
    ? o instanceof HTMLElement //DOM2
    : o &&
        typeof o === "object" &&
        true &&
        o.nodeType === 1 &&
        typeof o.nodeName === "string";
};

export const getSvgOpacityRatioOverLimit = async (
  svg_text_or_svg_el,
  opacity_limit_percent
) => {
  let paper_scope = new paper.PaperScope();
  paper_scope.activate();

  makePaperProject(
    paper_scope,
    1000,
    1000,
    document.getElementById("stickerizer")
  );

  paper_scope.project.importSVG(svg_text_or_svg_el, {
    onLoad: (item) => {
      // const bound_size = item.bounds.width * item.bounds.height;
      // console.log("total_size", bound_size);
      // console.log("item", item);
      // const opacity_limit = opacity_limit_percent / 100;
      // console.log("opacitylimit", opacity_limit);
      const raster = item.rasterize();
      const canvas = raster.canvas;
      const ctx = canvas.getContext("2d");

      const image_data = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const pixel_arr = image_data.data;
      let count_over_opacity_limit = 0;
      for (let i = 3; i < pixel_arr.length; i += 4) {
        if (pixel_arr[i] > (opacity_limit_percent / 100) * 255) {
          count_over_opacity_limit++;
        }
      }
      return (count_over_opacity_limit / pixel_arr.length) * 4 * 100;
    },
    expandShapes: true,
  });
};
